module.exports = __webpack_public_path__ + "img/ETriremeShip64_ua.cfc46dfd.webp";